import { render, staticRenderFns } from "./user-item.vue?vue&type=template&id=d8e71716&scoped=true&"
import script from "./user-item.vue?vue&type=script&lang=ts&"
export * from "./user-item.vue?vue&type=script&lang=ts&"
import style0 from "./user-item.vue?vue&type=style&index=0&id=d8e71716&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e71716",
  null
  
)

export default component.exports